import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import Header from "../../common/Header";
import ConnectBox from "./ConnectBox";

const App = () => {
	const [currentMenu, setCurrentMenu] = useState("General");
	const [showAPIModal, setShowAPIModal] = useState(false);
	const [user, setUser] = useState(null);

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		const menu = queryParams.get("menu");
		setCurrentMenu(menu || currentMenu);
	}, []);

	useEffect(() => {
		const connectContainer = document.getElementById("easycommerce-connect-box");
		if (connectContainer) {
			const root = createRoot(connectContainer);
			root.render(
				<ConnectBox user={user} setUser={setUser} setShowAPIModal={setShowAPIModal} />
			);
		}
	}, [user]);

	return (
		<Header
			breadcump={[ "Settings", currentMenu ].map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())}
			showAPIModal={showAPIModal}
			setShowAPIModal={setShowAPIModal}
			user={user}
			setUser={setUser}
		/>
	);
};

const container = document.getElementById("easycommerce-settings-header");
const root = createRoot(container);
root.render(<App />);
